import { Text, TextDescription, TextTitle } from "../components/Texts";
import { useDispatch, useSelector } from "react-redux";

import DateFormatter from "../modules/utils/DateFormatter";
import DatePicker from "../components/DatePicker";
import React from "react";
import Section from "../components/Section";
import Table from "../components/Table";
import _find from "lodash/find";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _orderBy from "lodash/orderBy";
import _split from "lodash/split";
import _values from "lodash/values";
import colors from "../styles/colors";
import { compose } from "redux";
import mainSelectors from "../modules/main/selectors";
import moment from "moment";

import performanceAction from "../modules/performance/actions";
import performanceSelectors from "../modules/performance/selectors";

import styled from "styled-components";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../layout/useWindowSize";
import withUserPerm from "services/withUserPerm";

import Loading from "components/Loading";
import TopBar from "components/TopBar";

const Performance = () => {
  //eslint-disable-next-line no-unused-vars
  const [t] = useTranslation();
  const dispatch = useDispatch();
  let selectedView = { title: "R-CRM", value: "R-CRM" };

  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const gReportList = useSelector((state) => performanceSelectors.greportList(state));
  const [selectedViewValue, setSelectedViewValue] = useState();
  const [yesterdayAsDefault, setYesterdayAsDefault] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataFirstLoaded, setDataFirstLoaded] = useState(false);

  useEffect(() => {
    setLoading(true);

    if (selectedViewValue && dataFirstLoaded === true) {
      const getPerformance = async () => {
        try {
          setLoading(true);
          await dispatch(
            performanceAction.GetGReportList({
              ads_account_id: currentAd.ads_account_id,
              date_preset: selectedViewValue.key,
            }),
          );
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      };
      getPerformance();
    } else if (dataFirstLoaded === false && selectedViewValue && selectedViewValue.key === "today") {
      setDataFirstLoaded(true);
    }
  }, [selectedViewValue, currentAd.ads_account_id, dispatch]);

  useEffect(() => {
    if (gReportList) {
      const performanceData = gReportList || {};

      if (!yesterdayAsDefault && selectedViewValue && selectedViewValue.key === "today" && performanceData) {
        setYesterdayAsDefault(true);
        setLoading(false);
      }
    }
  }, [gReportList, selectedViewValue]);

  return (
    <div>
      <StyledContainerTop useWindowSize={useWindowSize()}>
        <StyledContainerTopBar useWindowSize={useWindowSize()}>
          <TopBar title={t("__account_performance")} />
        </StyledContainerTopBar>
        <DatePicker
          key={moment.locale() + " " + yesterdayAsDefault}
          onSelected={setSelectedViewValue}
          defaultIndex={yesterdayAsDefault ? 1 : 0}
        />
      </StyledContainerTop>
      {loading === true ? (
        <Loading />
      ) : (
        <>
          <AllMetrics dataList={gReportList} view={selectedView} />
        </>
      )}
    </div>
  );
};

export default compose(withUserPerm())(Performance);

const AllMetrics = ({ dataList, view }) => {
  //eslint-disable-next-line no-unused-vars
  const isMobile = useWindowSize().width < 768;
  const [t] = useTranslation();
  const [selectedSortOption, setSelectedSortOption] = useState({ key: "date", direction: "desc" });
  let formatDate = DateFormatter.formatDateFull;

  if (view.value === "monthly") {
    formatDate = DateFormatter.formatMonthYear;
  }

  const tableColumns = [
    {
      key: "campaign_name",
      title: t("__campaign"),
      options: {
        width: "160px",
        strongText: true,
        fontSize: "10px",
      },
    },
    {
      key: "cost",
      title: t("__cost"),
      options: {
        align: "right",
      },
    },
    {
      key: "clicks",
      title: t("__clicks"),
      options: {
        align: "right",
      },
    },
    {
      key: "impressions",
      title: t("__impressions"),
      options: {
        align: "right",
      },
    },
    {
      key: "ctr",
      title: t("__ctr"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "cpc",
      title: t("__cpc"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "conversions",
      title: t("__conversion"),
      options: {
        align: "right",
      },
    },
  ];

  const sortOptions = {
    ...selectedSortOption,
    onSelected: setSelectedSortOption,
  };

  return (
    <Section margin="0 0 24px">
      <Table columns={tableColumns} data={dataList} responsiveColumns={2} maxHeight="280px" sortOptions={sortOptions} />
    </Section>
  );
};

const EmptyContent = () => {
  const [t] = useTranslation();
  return (
    <StyledEmptyContainer>
      <p>{t("__no_data")}</p>
    </StyledEmptyContainer>
  );
};

const StyledEmptyContainer = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

const StyledContainerTop = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "block" : "flex",
}))`
  display: ${(props) => props.display};
  justify-content: space-between;
  margin-bottom: 24px;
  display: ;
`;

const StyledContainerTopBar = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "none" : "block",
}))`
  display: ${(props) => props.display};
`;
